import StateCommodityName, { StateCommodityHeader } from '../components/StateCommodityName';
import LookupUrl from '../components/LookupUrl';
const columns = [
    { accessorKey: 'stateName', header: StateCommodityHeader, enableSorting: false,
        meta: { relatedFields: ['stateId', 'commodityId', 'commodityName'] }, cell: ({ row }) => <StateCommodityName record={row.original} /> },
    { accessorKey: 'licenseTypeName', header: 'License Type', enableSorting: false, meta: { relatedFields: ['licenseTypeId'] }, cell: ({ getValue }) => getValue() || '—' },
    { accessorKey: 'stateLicenseName', header: 'State License Name', enableSorting: false, cell: ({ getValue }) => getValue() || '—' },
    { accessorKey: 'isRequired', header: 'Required', enableSorting: false, cell: ({ getValue }) => getValue() == null ? '—' : getValue() ? 'Yes' : 'No' },
    { accessorKey: 'utilityCommissionLicenseURL', header: 'License URL', enableSorting: false, cell: ({ getValue }) => <LookupUrl value={getValue()} label="License website" /> },
];

export default columns;
